export const environment = {
  production: true,
  buildId: '4187247117625001',
  configFile: 'config.json',
};
